import { CreditCards } from "./CreditCards";

export default CreditCards;
